let voices = [];

// Load available voices (Ensure voices load properly)
const loadVoices = () => {
  voices = window.speechSynthesis.getVoices();
  if (voices.length === 0) {
    setTimeout(() => {
      voices = window.speechSynthesis.getVoices();
    }, 500);
  }
};

// Ensure voice list is populated
if (typeof window !== "undefined" && window.speechSynthesis) {
  window.speechSynthesis.onvoiceschanged = () => {
    loadVoices();
  };
  loadVoices(); // Initial call
}

// Function to split long text into manageable chunks
const splitTextIntoChunks = (plainText, maxChunkLength = 100) => {
  console.log('Plain Text:', plainText);

  // Helper to format years naturally
  const formatYear = (year) => {
    const yearNum = parseInt(year, 10);
    return yearNum >= 2000 ? `two thousand ${yearNum % 100}` : yearNum;
  };

  // Helper to format large numbers naturally
  const formatNumber = (num) => {
    const numInt = parseInt(num, 10);
    return numInt >= 1000 && numInt <= 9999
      ? `${Math.floor(numInt / 1000)} thousand ${numInt % 1000}`
      : num;
  };
  
  // Normalize and clean the text
  const normalizedText = plainText
  .replace(/CVE-(\d{4})-(\d{4,})/g, (_, year, id) => {
    return `CVE ${formatYear(year)}, ${formatNumber(id)}`;
  })
  .replace(/(\d+)-(\d+)/g, (_, start, end) => `${start} to ${end}`) // Convert ranges
  .replace(/\bCSP Policy\b/g, 'CSP') // Avoid "Content Security Policy Policy"
  .replace(/\bCSP\b/g, 'Content Security Policy') // Replace standalone CSP
  .replace(/\be\.g\./g, 'for example')
  .replace(/\bi\.e\./g, 'that is')
  .replace(/\betc\./g, 'and so on');

  // Custom markdown cleaner
  const cleanText = normalizedText
    .replace(/[*_~`>#-]/g, '') // Remove basic markdown characters
    .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Convert [text](link) to plain text
    .replace(/\n{2,}/g, '\n') // Normalize multiple newlines
    .replace(/\n\s*\*/g, '\n•') // Bullet points
    .replace(/\s*:\s*/g, ': ') // Normalize colons
    .replace(/([.!?])\s+/g, '$1\n') // Break after punctuation
    .replace(/;/g, ';\n') // Add breaks after semicolons for better readability
    .replace(/\n\s+/g, '\n') // Remove trailing whitespace after newlines
    .replace(/\s+$/gm, '') // Remove trailing spaces in each line
    .trim();

  console.log('Clean Text:', cleanText);

  // Split sentences and skip empty elements
  const sentences = cleanText.split(/(?<!\d)\.(?=\s)|(?<=:)\s+|\n+/).filter(Boolean);
  console.log('Sentences:', sentences);

  let chunks = [];
  let currentChunk = '';

  sentences.forEach((sentence) => {
    const trimmedSentence = sentence.trim();
    if (!trimmedSentence) return;

    if ((currentChunk + trimmedSentence).length <= maxChunkLength) {
      currentChunk += trimmedSentence + ' ';
    } else {
      if (currentChunk.trim()) chunks.push(currentChunk.trim());
      currentChunk = trimmedSentence + ' ';
    }
  });

  if (currentChunk.trim()) {
    chunks.push(currentChunk.trim());
  }

  console.log('Chunks:', chunks);
  return chunks;
};

// Narration Function with Chunking
const speakText = (text) => {
  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel(); // Stop any ongoing speech first
    
    const chunks = splitTextIntoChunks(text);
    let index = 0;

    const speakChunk = () => {
      if (index < chunks.length) {
        const speech = new SpeechSynthesisUtterance(chunks[index]);
        speech.lang = 'en-US';
        speech.rate = 1;
        speech.pitch = 1;
        speech.volume = 1;
        
        // Ensure voices are properly loaded
        speech.voice = voices.find(voice => voice.lang === 'en-US') || null;

        speech.onend = () => {
            index++;
            setTimeout(() => speakChunk(), 300); // Small pause to ensure smooth reading
        };

        window.speechSynthesis.speak(speech);
      }
    };

      // Ensure voices are loaded before speaking
    if (voices.length === 0) {
        window.speechSynthesis.onvoiceschanged = () => {
          voices = window.speechSynthesis.getVoices();
          speakChunk();
        };
      } else {
        speakChunk();
      }
  } else {
      console.error('Speech synthesis is not supported in this browser.');
  }
};

export default speakText;